/**
 * @fileoverview gRPC-Web generated client stub for documentgroup
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: documentgroup/documentgroup.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.documentgroup = require('./documentgroup_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.documentgroup.DocumentGroupServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.documentgroup.DocumentGroupServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.documentgroup.GetDocumentGroupRequest,
 *   !proto.documentgroup.GetDocumentGroupResponse>}
 */
const methodDescriptor_DocumentGroupService_GetDocumentGroup = new grpc.web.MethodDescriptor(
  '/documentgroup.DocumentGroupService/GetDocumentGroup',
  grpc.web.MethodType.UNARY,
  proto.documentgroup.GetDocumentGroupRequest,
  proto.documentgroup.GetDocumentGroupResponse,
  /**
   * @param {!proto.documentgroup.GetDocumentGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.documentgroup.GetDocumentGroupResponse.deserializeBinary
);


/**
 * @param {!proto.documentgroup.GetDocumentGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.documentgroup.GetDocumentGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.documentgroup.GetDocumentGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.documentgroup.DocumentGroupServiceClient.prototype.getDocumentGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/GetDocumentGroup',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_GetDocumentGroup,
      callback);
};


/**
 * @param {!proto.documentgroup.GetDocumentGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.documentgroup.GetDocumentGroupResponse>}
 *     Promise that resolves to the response
 */
proto.documentgroup.DocumentGroupServicePromiseClient.prototype.getDocumentGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/GetDocumentGroup',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_GetDocumentGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.documentgroup.GetDocumentGroupsResponse>}
 */
const methodDescriptor_DocumentGroupService_GetDocumentGroups = new grpc.web.MethodDescriptor(
  '/documentgroup.DocumentGroupService/GetDocumentGroups',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.documentgroup.GetDocumentGroupsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.documentgroup.GetDocumentGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.documentgroup.GetDocumentGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.documentgroup.GetDocumentGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.documentgroup.DocumentGroupServiceClient.prototype.getDocumentGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/GetDocumentGroups',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_GetDocumentGroups,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.documentgroup.GetDocumentGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.documentgroup.DocumentGroupServicePromiseClient.prototype.getDocumentGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/GetDocumentGroups',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_GetDocumentGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.documentgroup.UploadDocumentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DocumentGroupService_UploadDocument = new grpc.web.MethodDescriptor(
  '/documentgroup.DocumentGroupService/UploadDocument',
  grpc.web.MethodType.UNARY,
  proto.documentgroup.UploadDocumentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.documentgroup.UploadDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.documentgroup.UploadDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.documentgroup.DocumentGroupServiceClient.prototype.uploadDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/UploadDocument',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_UploadDocument,
      callback);
};


/**
 * @param {!proto.documentgroup.UploadDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.documentgroup.DocumentGroupServicePromiseClient.prototype.uploadDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/UploadDocument',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_UploadDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.documentgroup.DeleteDocumentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DocumentGroupService_DeleteDocument = new grpc.web.MethodDescriptor(
  '/documentgroup.DocumentGroupService/DeleteDocument',
  grpc.web.MethodType.UNARY,
  proto.documentgroup.DeleteDocumentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.documentgroup.DeleteDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.documentgroup.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.documentgroup.DocumentGroupServiceClient.prototype.deleteDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_DeleteDocument,
      callback);
};


/**
 * @param {!proto.documentgroup.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.documentgroup.DocumentGroupServicePromiseClient.prototype.deleteDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/documentgroup.DocumentGroupService/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_DocumentGroupService_DeleteDocument);
};


module.exports = proto.documentgroup;

